import React from "react";
import { Link } from "react-router-dom";
import { useSiteImages } from "../context/SiteImagesContext";

export function Logo({ to = "/", size = 32 }) {
  const { img } = useSiteImages();
  return (
    <Link to={to} className="flex items-center gap-2" data-testid="app-logo">
      <img src={img("logo")} alt="ilovemuzik" style={{ width: size, height: size }}
        className="rounded-lg object-contain bg-black shrink-0" />
      <span className="font-display font-extrabold tracking-tight">ILOVE<span className="gradient-text">MUZIK</span></span>
    </Link>
  );
}
